import { useGetApplication } from '../../../../hooks';

import { baseUrl } from './service';

export const useGetEnabledRegistrationFields = () => {
  return useGetApplication<Array<string>>({ url: baseUrl, params: {} });
};
